
const Footer = () => {
  return (
    <footer className="mt-5 text-center p-2 pb-4"> &copy; Copyright {new Date().getFullYear()} </footer>
  )
}

export default Footer